import React from 'react';
import NoDataOverlay from './NoDataOverlay';

const NoResultsOverlay: React.FC = () => (
	<NoDataOverlay messageId="grid.data.no.results.overlay" />
);

export default NoResultsOverlay;
